import cn from './style.module.sass';

type CertificatesDescriptionProps = {
    description: string;
};
export default function CertificatesDescription({ description }: CertificatesDescriptionProps) {
    return <div className={cn['certificates-description']}>{description}</div>;
}
